import { Mut } from '@efficiently/shared-util-types';

import { isPlainObject } from './is-plain-object';

function normalizeValue(value: unknown, seen: WeakSet<object>): unknown {
	if (value === null || typeof value !== 'object') {
		return value;
	}

	if (seen.has(value)) {
		return '[Circular]';
	}

	seen.add(value);

	if (Array.isArray(value)) {
		return value.map(item => normalizeValue(item, seen));
	}

	if (value instanceof Date) {
		return value.toISOString();
	}

	if (!isPlainObject(value)) {
		return Object.prototype.toString.call(value);
	}

	return Object.keys(value)
		.sort()
		.reduce<Record<string, unknown>>((acc: Mut<Record<string, unknown>>, key) => {
			acc[key] = normalizeValue(value[key], seen);

			return acc;
		}, {});
}

export function stableStringify(value: unknown): string {
	return JSON.stringify(normalizeValue(value, new WeakSet<object>())) ?? '';
}
